import { defineMessages } from 'react-intl';

export default defineMessages({
    IsSpouseOrPartner: {
        id: 'qnb.spm.additionalDriverPage.aboutYou.IsSpouseOrPartner',
        defaultMessage: 'Is this driver your named spouse/domestic partner?'
    }
});
